export const SET_ERROR = 'SET_ERROR';
export const UNSET_ERROR = 'UNSET_ERROR';
export const SET_WECHAT_QR_CODE = 'SET_WECHAT_QR_CODE';
export const RESET_INTEGRATIONS = 'RESET_INTEGRATIONS';
export const SET_TWILIO_INTEGRATION_STATE = 'SET_TWILIO_INTEGRATION_STATE';
export const RESET_TWILIO_INTEGRATION_STATE = 'RESET_TWILIO_INTEGRATION_STATE';
export const SET_MESSAGEBIRD_INTEGRATION_STATE = 'SET_MESSAGEBIRD_INTEGRATION_STATE';
export const RESET_MESSAGEBIRD_INTEGRATION_STATE = 'RESET_MESSAGEBIRD_INTEGRATION_STATE';
export const SET_VIBER_QR_CODE = 'SET_VIBER_QR_CODE';
export const SET_LINK_REQUEST = 'SET_LINK_REQUEST';
export const RESET_LINK_REQUEST = 'RESET_LINK_REQUEST';
export const SET_WHATSAPP_CODE_WHILE_LOADING = 'SET_WHATSAPP_CODE_WHILE_LOADING';
